import React from 'react'

import { compile } from '~/apps/applicationAdmin/routes/paths'
import {
  RedirectOrError,
  type RedirectOrErrorProps,
} from '~/components/features/RedirectOrError/'

const getRedirectPath: RedirectOrErrorProps['getRedirectPath'] = () => ({
  success: true,
  path: compile('brandAccountsList', {}),
})

export const ApplicationAdminTopPage = () => (
  <RedirectOrError getRedirectPath={getRedirectPath} />
)
